import react, {useEffect, useMemo} from 'react';
import MyTable from '../components/myTable';
import {useSelector} from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Cookie from 'react-cookies';
import { FaPlus } from 'react-icons/fa';
import { getGallery, userList } from '../../api/api';

const Gallery = () => {
    // const marginLeft = useSelector(state => state.style.payload.marginLeft)
    const navigate = useNavigate();
    const data = useSelector((state) => state.gallery.gallery);
    console.log(data);
   
    
    const columns = useMemo( () => [
        {
            Header: '#',
            accessor: (data, i) => {
                return (i+1)
            }
        },
        {
            Header: 'Photo',
            accessor: ((data) => (
                <img src={data.img} width={'100%'} height={100} />
            ))
        },
        {
            Header: 'title',
            accessor: 'title',
        },
        {
            Header: 'Date',
            accessor: 'created_at'
        },
        {
            Header: 'Action',
            accessor: (data, i) => 
                (
                    <span id='' className='drop-down'
                    style={{ width: '150px' }}
                    > 
                        <button
                        // id='action'
                        className='form-select'
                         style={{ 
                            fontSize: 12
                          }}
                        onClick={() => {
                            let element = document.getElementById('child'+i);
                            
                            element.classList.toggle('open');
                        }}
                        >
                            Action
                        </button>
                        <div id={'child'+i} class="table-action-box form-control">
                             <button className='btn form-control text-start'
                             style={{ 
                                fontSize: 12
                              }}
                             onClick={() => {
                                Cookie.save('eventItem', JSON.stringify(data));
                                // navigate('/view_store_item');
                             }}
                             > View </button>

                             <button className='btn form-control text-start'
                             style={{ 
                                fontSize: 12
                              }}
                             onClick={() => {
                                Cookie.save('eventItem', JSON.stringify(data));
                                // navigate('/update_store_item');
                             }}
                             > Delete </button>
                        </div>
                    </span>
                )
            
        }
    ], [])

    useEffect(() => {
        // data.length == 0 && getUsers();
        data.length == 0 && getGallery();
        console.log(data)
        document.title = 'Gallery | Bida Sport Club'
    }, [])
    
    return data.length > 0 ? (
        <div className=''> 
            {/* <h2> Users </h2> */}
            <MyTable data ={data} columns={columns} pageName = {"BSC Gallery"}
             button = {<button className='btn btn-md btn-color'
             style={{ 
                 // width:'170px',
                 height: '40px'
              }}
             onClick={()=> navigate('/new_gallery_image')}
             > <FaPlus /> Add New Photo </button>}
            />
        </div>
    ):
    (
        <div className=' row justify-content-center py-5'>
            <h4> <b className="mb-5 ms-5">Gallery </b> </h4>
            <h3> <p className="mb-5 ms-5 text-center">Gallery is Empty.</p> </h3>
        </div>
    )
}

export default Gallery